import { useAuthContext } from '../context/auth/AuthContext';

const useAuth = () => {
  const { state } = useAuthContext();

  return {
    isAuthenticated: !!state.user,
    loading: state.loading,
    user: state.user,
  };
};

export default useAuth;
